import { Box, createStyles, makeStyles, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BUTTON_BACKGROUND,
  DARK_CARDS_CONTAINER,
  DARK_CONTAINER_BORDER,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  DARK_SECONDARY_BUTTONBACKGROUND,
  ERROR_CONTAINER_BORDER,
  LIGHT_CONTAINER_BORDER,
  LIGHT_CONTAINER,
  LIGHT_HEADER_LINE,
  PRIMARY_HEADER_LINE,
} = COLORS;
const ERROR_CONTAINER = 'rgba(230, 105, 107, 0.3)';
export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      gap: '2em',

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    },

    container: {
      height: 'fit-content',
      background: theme.palette.type === 'dark' ? DARK_CARDS_CONTAINER : LIGHT_CONTAINER,
      border: 'none',
      borderRadius: 8,
      padding: 30,
      width: '100%',
      position: 'relative',
      [theme.breakpoints.down('xs')]: {
        padding: 15,
      },
    },

    containerWarn: {
      display: 'flex',
      gap: 20,
      height: 'fit-content',
      backgroundColor: ERROR_CONTAINER,
      border: `1px solid ${ERROR_CONTAINER_BORDER}`,
      borderRadius: 8,
      padding: '16.5px 32.2px 17.5px 20.5px',
      width: '100%',
      position: 'relative',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        padding: 15,
        flexDirection: 'column',
        gap: 30,
      },
    },

    left: {
      height: 'fit-content',
      maxWidth: 550,
      [theme.breakpoints.down('md')]: {
        maxWidth: 'unset',
      },
    },

    rightContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '2em',
    },

    heading: {
      flex: 1,
    },

    content: {},

    footer: {
      display: 'flex',
      gap: 20,

      marginTop: 50,

      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },

    buttonCls: {
      height: '50px !important',
      borderRadius: 8,
      textTransform: 'unset',
      width: '100%',
      fontSize: 15,
      maxWidth: 320,
      [theme.breakpoints.down('xs')]: {
        maxWidth: 'unset',
      },
    },

    clearButton: {
      background: DARK_BUTTON_BACKGROUND,

      '&:hover': {
        background: DARK_SECONDARY_BUTTONBACKGROUND,
      },
    },

    link: {
      textDecoration: 'none',
      width: '100%',
    },
  }),
);

export const HeaderCont = styled(Box)(({ theme }) => ({
  gap: 10,
  display: 'flex',
  borderBottom:
    theme.palette.type === 'dark' ? `1px solid ${DARK_FIELDS_ON_CARD_HEADER_LINE}` : `1px solid ${LIGHT_HEADER_LINE}`,
  position: 'relative',
  alignItems: 'center',
  paddingBottom: 10,
  marginBottom: 10,
  justifyContent: 'space-between',
  width: '100%',
  '&::before': {
    content: '""',
    background: PRIMARY_HEADER_LINE,
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
}));
